import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MembershipService} from '../../../../../../@shared/services/membership-service';
import {MembershipPlanResponse} from '../../../../../../@shared/models/response.module';
import {_AQH_MEM_6} from '../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-edit-membership-plan',
  standalone: false,
  templateUrl: './edit-membership-plan.html',
  styleUrl: './edit-membership-plan.css'
})
export class EditMembershipPlan {
  @Input() plan: MembershipPlanResponse;
  code: string = '';
  name: string = '';
  coverage: string = '';
  billing_cycle: string = '';
  price_cents: number = 0;
  max_children: number | null = null;
  saving: boolean = false;

  constructor(private membershipService: MembershipService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.code = this.plan.code;
    this.name = this.plan.name;
    this.coverage = this.plan.coverage;
    this.billing_cycle = this.plan.billing_cycle;
    this.price_cents = this.plan.price_cents / 100; // Convert cents to dollars
    this.max_children = this.plan.max_children;
  }

  onSave() {
    if (!this.code.trim() || !this.name.trim() || !this.coverage) {
      return;
    }

    this.saving = true;
    const params: _AQH_MEM_6 = {
      plan_id: this.plan.plan_id,
      code: this.code,
      name: this.name,
      coverage: this.coverage,
      billing_cycle: this.billing_cycle,
      price_cents: this.price_cents * 100, // Convert dollars to cents
      max_children: this.coverage === 'family' ? (this.max_children ?? undefined) : undefined
    };

    this.membershipService.updateMembershipPlan(params).subscribe({
      next: () => {
        this.saving = false;
        this.modal.close(true);
      },
      error: () => {
        this.saving = false;
      }
    });
  }

  close() {
    this.modal.close();
  }
}
